import { useConfigContext } from "../providers/ConfigProvider";

type PropsType = {
    contain?: string;
}

const Logo = (props: PropsType) => {
    const { contain = "end" } = props;
    const { data } = useConfigContext();

    return (
        <img src={`${import.meta.env.VITE_API_BASE_URL}${data?.logo}`} alt="Logo til stiftelsen" className={`object-fit-contain ${contain === "end" ? "object-position-right" : "object-position-center"} header-logo`} />
    )
}

export default Logo;